import React from "react";
import { Box, Typography, useTheme } from "@mui/material";

const AboutUs = () => {
  const theme = useTheme();

  return (
    <Box id="AboutUs" sx={{ px: { xs: 2, sm: 0, md: 0 } }}>
      <Typography
        variant="h4"
        align="center"
        sx={{
          fontWeight: 600,
          letterSpacing: 1,
          fontFamily: theme.fonts.secondary,
          color: theme.palette.primary.main,
        }}
      >
        ABOUT US
      </Typography>

      {/* Title */}
      <Typography
        variant="h6"
        align="center"
        sx={{
          fontWeight: 400,
          mb: { xs: 2, md: 2 },
          color: theme.palette.secondary.main,
          fontWeight: "bold",
          mt: 1,
        }}
      >
        The Wellness VC
      </Typography>

      <Box sx={{
        display:'flex',
        justifyContent:'center', 
        alignItems:'center'
      }}>
        <Typography
          variant="body1"
          sx={{
            fontWeight: 400,
            mb: { xs: 2, md: 5 },
            mt: 1,
            color: "#1D4979",
            maxWidth: "700px",
            textAlign: "left",
          }}
        >
          Cistern invests in startups solving America's greatest health
          challenges. We back purpose-led founders on personal missions to
          tackle issues like chronic disease, mental illness, and environmental
          harm. <br />
          <br /> Our portfolio spans all 8 dimensions of wellness - physical,
          financial, social, emotional, spiritual, intellectual, occupational,
          and environmental - to create scalable, multidimensional solutions
          with outsized societal impact.
        </Typography>
      </Box>
    </Box>
  );
};

export default AboutUs;
